export function formatSecondsToMinSec(seconds) {
  if (isNaN(seconds)) return "0s";
  
  const mins = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);
  
  let result = '';
  if (mins > 0) result += `${mins}m `;
  result += `${secs}s`;
  
  return result;
}